import { render, staticRenderFns } from "./CompanyPropagate.vue?vue&type=template&id=8d1119a8&scoped=true"
import script from "./CompanyPropagate.vue?vue&type=script&lang=js"
export * from "./CompanyPropagate.vue?vue&type=script&lang=js"
import style0 from "./CompanyPropagate.vue?vue&type=style&index=0&id=8d1119a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1119a8",
  null
  
)

export default component.exports